import { z } from "zod";
/** Catálogo de categorías de insight (Req. 1, 28 sep 2026). */
export const categorySummary = z.object({
    id: z.uuid(),
    name: z.string(),
    studyCount: z.number().int(),
});
export const categoryList = z.object({ items: z.array(categorySummary) });
/** El mismo límite que `study.category`. */
export const categoryNameInput = z.object({
    name: z.string().trim().min(1).max(100),
});
//# sourceMappingURL=category.js.map